export default {
    alertActions: 'Notification Settings',
    alertRules: 'Alert Rules',
    alerts: 'Alerts',
    alertType: 'Alert Type',
    door_held_open: 'Door Held Open',
    door_forced_open: 'Door Forced Open',
    device_status: 'Device Network Status',
    duration: 'Duration (seconds)',
    maxDailyAlerts: 'Max Daily Alerts',
    createRule: 'Create Alert Rule',
    deleteRule: 'Delete Rule',
    deactivateRuleConfirm: 'Are you sure you want to delete this alert rule?',
    email: 'Email',
    sms: 'SMS',
    'in-app': 'In-App',
    createAction: 'Add Notification',
    deliveryInfo: 'Delivery Info',
    actionDetails: 'Notification Settings Details',
    phoneNumber: 'Phone Number',
    alertRule: 'Rule',
    alertAction: 'Notification',
    alertsHistory: 'Active Alerts',
    paused: 'Paused',
    snoozeAlertTill: 'Snooze Alert Till',
    deliveryChannels: 'Delivery Channels',
    snoozed: 'Snoozed',
    unSnooze: 'Unsnooze',
    unSnoozeConfirm: 'Are you sure you want to unsnooze this rule?',
    alertConditions: 'Alert Conditions',
    durationExtra: 'Time in seconds before triggering an alert if the door remains open after access.',
    incident: 'Incident',
    pleaseSelectDate: 'Please select a date',
    alertingSystem: 'Alerting System',
    additionalEmails: 'Additional emails',
    additionalPhoneNumbers: 'Additional Phone numbers',
    typeMessages: {
        heldOpenMsg: 'An alert will be triggered when a door remains open beyond the allowed time.',
        forcedOpenMsg: 'An alert will be triggered when a door is forced open without authorization',
        helpMsg: 'Choose the event that will trigger the alert.',
        deviceStatusMsg:
            'An alert will be triggered when any of the intercom devices goes offline for 30 minutes or more and also when it comes back online. Alert goes once a day per device.',
    },
    maxDailyAlertsHelpTxt: 'Specify the max number of alert notifications per day.',
    ruleDoorHelpTxt: 'Alerts will be triggered only for the selected access points (doors, elevators...).',
    addNotificationMapping: 'Map Notification Settings',
    addRuleMapping: 'Map Alert Rule',
    snoozeHelpTxt: 'No new alerts will trigger for this rule while it is in a snoozed state.',
    unSnoozeHelpTxt: 'Un-snooze this rule to start receiving notifications again.',
    notificationRecipients: 'Notification Recipients',
    additionalEmailList: 'Additional Emails',
    additionalPhoneList: 'Additional Phone Numbers',
    createAlertRule: 'Create Alert Rule',
    ruleName: 'Rule Name',
    ruleDesc: 'Rule Description',
    ruleSettings: 'Alert Rule',
    notificationSettings: 'Notification Settings',
    notificationName: 'Notification Name',
    notificationDesc: 'Notification Description',
    selectDeliveryChanel: 'Select notification delivery channel/s',
    selectNotificationUsers: 'Select users who should receive notifications',
    selectNotificationGroups: 'Select access groups who should receive notifications',
    additionalEmailsHelpTxt: 'Provide additional email ids who should receive notifications',
    additionalPhonesHelpTxt: 'Provide additional phone numbers who should receive notifications',
    triggered: 'Triggered',
    resolved: 'Resolved',
    configAlert: 'Configure Alert',
    deactivated: 'Deactivated',
    activateRule: 'Activate Rule',
    deactivateRule: 'Deactivate Rule',
    viewAlerts: 'View Alerts',
};
